import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useLicense } from '../../context/LicenseContext';

// Garde de route par module de licence : accès direct par URL refusé si le module
// n'est pas souscrit (redirection vers le dashboard). Ordre = plus spécifique d'abord.
const PATH_MODULE = [
    ['/stock-scanner', 'mod_stock'],
    ['/stock-transfer', 'mod_stock'],
    ['/stocks', 'mod_stock'],
    ['/inventory/print-labels', 'mod_etiquette'],
    ['/inventory', 'mod_inventory'],
    ['/suppliers', 'mod_supplier'],
    ['/analytics', 'mod_report'],
    ['/smart-order', 'mod_reappro'],
    ['/purchase-orders', 'mod_purchase'],
    ['/warehouses', 'mod_warehouse'],
];

const MainLayout = ({ children }) => {
    const location = useLocation();
    const { hasModule } = useLicense();
    const match = PATH_MODULE.find(([p]) => location.pathname.startsWith(p));
    if (match && !hasModule(match[1])) {
        return <Navigate to="/dashboard" replace />;
    }
    return (
        <div className="flex h-screen w-full flex-col overflow-hidden bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100 font-display transition-colors">
            <Header />
            <div className="flex flex-1 overflow-hidden">
                <Sidebar />
                <main className="flex-1 overflow-y-auto px-6 pb-6 pt-4 lg:px-10 lg:pb-10 lg:pt-6">
                    <div className="max-w-[1600px] mx-auto w-full flex flex-col gap-8">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
